import { UserTenant } from '@root/globalTypes';
import { getCustomSetting } from '@utils/customSettings';
import { Emptied } from '@utils/types';

const FULL_DAY_START = 0;
const FULL_DAY_END = 24;

export interface TenantScheduleHoursDefaults {
  dayStart: number;
  dayEnd: number;
}

export const getTenantScheduleHours = (
  tenant: Emptied<UserTenant> | undefined,
  defaults: TenantScheduleHoursDefaults,
  showFullDay?: boolean,
) => {
  if (showFullDay) return { dayStart: FULL_DAY_START, hoursCount: FULL_DAY_END - FULL_DAY_START };

  const dayStart =
    (getCustomSetting(tenant, 'scheduler_starting_hour') as number) ?? defaults.dayStart;
  const dayEnd = (getCustomSetting(tenant, 'scheduler_ending_hour') as number) ?? defaults.dayEnd;

  return { dayStart, hoursCount: dayEnd - dayStart };
};
